module.exports = __webpack_public_path__ + "img/S__8757256.31f80283.jpg";